import { z } from 'zod/v4-mini';

import { GeneralBackendResponseSchema } from '$/services/mapper/authentication';

const BaseInvitationRequestSchema = z.object({
  id: z.string(),
  email: z.string(),
  expirationDate: z.optional(z.string()),
});

export const StudentInvitationRequestSchema = z.object({
  ...BaseInvitationRequestSchema.shape,
  type: z.literal('student'),
  firstName: z.string(),
  lastName: z.string(),
  isNewAccount: z.boolean(),
  schoolClassId: z.string(),
  schoolId: z.string(),
  schoolName: z.string(),
  schoolClassName: z.string(),
});

export const SchoolInvitationRequestSchema = z.object({
  ...BaseInvitationRequestSchema.shape,
  type: z.literal('school'),
  name: z.string(),
  countryId: z.string(),
  address: z.string(),
  department: z.string(),
  phone: z.string(),
  website: z.string(),
  accountVerified: z._default(z.boolean(), true),
});

export const TeacherInvitationRequestSchema = z.object({
  ...BaseInvitationRequestSchema.shape,
  type: z.literal('teacher'),
  firstName: z.string(),
  lastName: z.string(),
  isNewAccount: z.boolean(),
  schoolId: z.string(),
  schoolName: z.string(),
});

export const InvitationRequestSchema = z.discriminatedUnion('type', [
  StudentInvitationRequestSchema,
  SchoolInvitationRequestSchema,
  TeacherInvitationRequestSchema,
]);

export type InvitationRequest = z.infer<typeof InvitationRequestSchema>;

export type StudentInvitationRequest = z.infer<
  typeof StudentInvitationRequestSchema
>;

export type SchoolInvitationRequest = z.infer<
  typeof SchoolInvitationRequestSchema
>;

export type TeacherInvitationRequest = z.infer<
  typeof TeacherInvitationRequestSchema
>;

export const GetInvitationRequestSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: InvitationRequestSchema,
});

export const GetStudentInvitationsRequestSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(StudentInvitationRequestSchema),
});

export const GetSchoolInvitationsRequestsSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(SchoolInvitationRequestSchema),
});

export const GetTeacherInvitationsRequestSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.array(TeacherInvitationRequestSchema),
});

export const GenerateSchoolVerificationFileLinkRequestSchema = z.object({
  ...GeneralBackendResponseSchema,
  payload: z.object({
    signedUrl: z.string(),
  }),
});
